export default __webpack_public_path__ + "4587d9028f5ab31a68c29f9163617993.png";